/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Confirm_TitleInputs */

const en_directory_promotion_confirm_title = /** @type {(inputs: Directory_Promotion_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm the preview`)
};

const zh_directory_promotion_confirm_title = /** @type {(inputs: Directory_Promotion_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认预览`)
};

/**
* | output |
* | --- |
* | "Confirm the preview" |
*
* @param {Directory_Promotion_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_confirm_title = /** @type {((inputs?: Directory_Promotion_Confirm_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Confirm_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_confirm_title(inputs)
	return zh_directory_promotion_confirm_title(inputs)
});
export { directory_promotion_confirm_title as "directory.promotion.confirm_title" }